import {Preview, template as tpl} from "./Preview";
import departmentHtml from './department.html?raw';

export let template = tpl.replace('<!-- {{TEMPLATE_ROW}} -->', departmentHtml);

export class viewModel extends Preview {

    constructor(params: any) {
        super(params);
        this.table = [
            {
                key: "id",
                sort: false
            },
            {
                key: "Department",
                sort: true
            },
            {
                key: "SourceId",
                sort: true
            }
        ];
        this.searchcolumn("Department");
    }

}
